<template>
   <el-tabs type="border-card" style="height:auto">
    <el-tab-pane label="线下发票申请" style="height:auto" >
      <el-form :inline="true" :model="orderInvoiceForm" class="demo-form-inline">
        <el-form-item label="订单编号">
          <el-input size="mini" v-model.trim="orderInvoiceForm.orderNo" placeholder="订单编号"></el-input>
        </el-form-item>
        <el-form-item label="登录用户名">
          <el-input size="mini" v-model.trim="orderInvoiceForm.userName" placeholder="登录用户名"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="mini" type="primary" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="data" height="710" style="height:auto" border>
        <el-table-column fixed type="expand" Scoped slot>
          <template slot-scope="props">
            <el-tabs v-model="activeMainName" @tab-click="handleClick" style="width:100%;height:auto">
              <el-tab-pane label="主订单详情" name="firstMain">
                <el-table :data="props.row.mainOrderList" style="width:100%;height:auto">
                  <el-table-column fixed type="expand" Scoped slot>
                    <template slot-scope="props">
                      <el-tabs v-model="activeName" @tab-click="handleClick(props.row)" style="width:100%">
                        <el-tab-pane label="子订单详情" name="first">
                          <el-table :data="props.row.childList"  border style="width:100%;">
                            <el-table-column
                              prop="manufacturerNumber"
                              show-overflow-tooltip
                              fixed
                              label="产品型号"
                              width="220">
                            </el-table-column>
                            <el-table-column
                              prop="brandName"
                              show-overflow-tooltip
                              label="品牌"
                              width="110">
                            </el-table-column>
                            <el-table-column
                              prop="originalPrice"
                              show-overflow-tooltip
                              label="商品原单价"
                              width="100">
                            </el-table-column>
                            <el-table-column
                              prop="discountedPrice"
                              show-overflow-tooltip
                              label="购买价格"
                              width="100">
                            </el-table-column>
                            <el-table-column
                              prop="count"
                              label="购买数量"
                              width="80">
                            </el-table-column>
                            <el-table-column
                              prop="attachAmount"
                              label="附加费"
                              width="80">
                            </el-table-column>
                            <el-table-column
                              prop="preferentialMargins"
                              label="总优惠"
                              width="80">
                            </el-table-column>
                            <el-table-column
                              label="状态"
                              width="80">
                              <template slot-scope="scope">
                                <span v-if="scope.row.orderStatus == -4" style="color:#989998">支付失败</span>
                                <span v-if="scope.row.orderStatus == -3" style="color:#989998">已退款</span>
                                <span v-if="scope.row.orderStatus == -2" style="color:#989998">退款申请</span>
                                <span v-if="scope.row.orderStatus == -1" style="color:#989998">已取消</span>
                                <span v-if="scope.row.orderStatus == 0" style="color:#F56C6C">待确认</span>
                                <span v-if="scope.row.orderStatus == 1" style="color:#F56C6C">待付款</span>
                                <span v-if="scope.row.orderStatus == 2" style="color:#E6A23C">部分付款</span>
                                <span v-if="scope.row.orderStatus == 21" style="color:#F56C6C">预付订单</span>
                                <span v-if="scope.row.orderStatus == 3" style="color:#E6A23C">支付成功</span>
                                <span v-if="scope.row.orderStatus == 4" style="color:#67C23A">待发货</span>
                                <span v-if="scope.row.orderStatus == 5" style="color:#67C23A">发货中</span>
                                <span v-if="scope.row.orderStatus == 6" style="color:#409EFF">已发货</span>
                                <span v-if="scope.row.orderStatus == 7" style="color:#989998">已完成</span>
                              </template>
                            </el-table-column>
                            <el-table-column
                              prop="originalAmount"
                              label="原总金额"
                              width="95">
                            </el-table-column>
                            <el-table-column
                              prop="totalAmount"
                              label="总金额"
                              width="95">
                            </el-table-column>
                           </el-table>
                        </el-tab-pane>
                        <el-tab-pane label="交易记录" name="third">
                          <el-table
                            :data="props.row.payRecordList"
                            style="height:100%;"
                            border>
                            <el-table-column
                              fixed
                              prop="supplementNo"
                              label="支付编号"
                              width="220"
                              >
                            </el-table-column>
                            <el-table-column
                              prop="outPayNo"
                              label="第三方支付编号"
                              width="260"
                              >
                            </el-table-column>
                            <el-table-column
                              prop="payType"
                              :formatter="formatPayType"
                              show-overflow-tooltip
                              label="支付类型"
                              width="80"
                              >
                            </el-table-column>
                            <el-table-column
                              prop="payStatus"
                              :formatter="formatPayStatus"
                              label="状态"
                              width="100">
                              <template slot-scope="scope">
                                <span v-if="scope.row.payStatus == 1" style="color:#F56C6C">待处理</span>
                                <span v-if="scope.row.payStatus == 2" style="color:#67C23A">已完成</span>
                              </template>
                            </el-table-column>
                            <el-table-column
                              prop="payMethod"
                              :formatter="formatPay"
                              label="付款方式"
                              width="100"
                              >
                            </el-table-column>
                            <el-table-column
                              prop="payAmount"
                              label="预付金额"
                              width="100">
                            </el-table-column>
                            <el-table-column
                              prop="realAmount"
                              label="已付金额"
                              width="100"
                              >
                            </el-table-column>
                            <el-table-column
                              prop="reason"
                              show-overflow-tooltip
                              label="备注">
                            </el-table-column>
                            <el-table-column
                              show-overflow-tooltip
                              prop="payTime"
                              label="付款时间">
                            </el-table-column>
                          </el-table>
                        </el-tab-pane>
                        <el-tab-pane label="发票信息" name="fourth">
                          <template v-if="props.row.userInvoiceResponseVo">
                            <el-form>
                              <el-form-item label="发票类型" :label-width="formLabelWidth">
                              <el-select v-model="props.row.userInvoiceResponseVo.type" placeholder="请选择">
                                <el-option
                                  v-for="item in options"
                                  :key="item.value"
                                  :label="item.label"
                                  :value="item.value">
                                </el-option>
                              </el-select>
                              </el-form-item>
                              <el-form-item label="发票抬头" :label-width="formLabelWidth"> 
                                <el-input v-model="props.row.userInvoiceResponseVo.companyName"  autocomplete="off"></el-input>
                              </el-form-item>
                              <el-form-item label="税务登记号" :label-width="formLabelWidth">
                                <el-input v-model="props.row.userInvoiceResponseVo.invoiceNumber" autocomplete="off"></el-input>
                              </el-form-item>
                              <el-form-item label="公司注册地址" :label-width="formLabelWidth" v-show="props.row.userInvoiceResponseVo.type == 2">
                                <el-input v-model="props.row.userInvoiceResponseVo.companyAddress" autocomplete="off"></el-input>
                              </el-form-item>
                              <el-form-item label="公司电话" :label-width="formLabelWidth" v-show="props.row.userInvoiceResponseVo.type == 2">
                                <el-input v-model="props.row.userInvoiceResponseVo.companyMobile" autocomplete="off"></el-input>
                              </el-form-item>
                              <el-form-item label="开户银行" :label-width="formLabelWidth" v-show="props.row.userInvoiceResponseVo.type == 2">
                                <el-input v-model="props.row.userInvoiceResponseVo.bankName" autocomplete="off"></el-input>
                              </el-form-item>
                              <el-form-item label="开户银行账号" :label-width="formLabelWidth" v-show="props.row.userInvoiceResponseVo.type == 2">
                                <el-input v-model="props.row.userInvoiceResponseVo.bankNumber" autocomplete="off"></el-input>
                              </el-form-item>
                              <el-form-item label="收票人" :label-width="formLabelWidth" v-show="props.row.userInvoiceResponseVo.type == 2">
                                <el-input v-model="props.row.userInvoiceResponseVo.consignee" autocomplete="off"></el-input>
                              </el-form-item>
                              <el-form-item label="收票地址" :label-width="formLabelWidth" v-show="props.row.userInvoiceResponseVo.type == 2">
                                <el-input v-model="props.row.userInvoiceResponseVo.addressDetail" autocomplete="off"></el-input>
                              </el-form-item>
                              <el-form-item label="手机号码" :label-width="formLabelWidth" v-show="props.row.userInvoiceResponseVo.type == 2">
                                <el-input v-model="props.row.userInvoiceResponseVo.mobile" autocomplete="off"></el-input>
                              </el-form-item>
                              <el-form-item label="电子版盖章开票信息" :label-width="formLabelWidth" v-show="props.row.userInvoiceResponseVo.type == 2">
                                <el-image :src="props.row.userInvoiceResponseVo.invoiceFile" ></el-image>
                              </el-form-item>
                            </el-form>
                          </template>
                          <template v-else>
                            <div style="padding: 10px 0 20px 0; width: 60%; text-align:center;">
                              暂无
                            </div>
                          </template>
                        </el-tab-pane>
                        <el-tab-pane label="合同记录" name="five">
                          <template v-if="props.row.contractRecordList">
                            <el-table
                              :data="props.row.contractRecordList"
                              border
                              style="width: 75%">
                              <el-table-column
                                prop="contractNo"
                                show-overflow-tooltip
                                label="合同编号">
                              </el-table-column>
                              <el-table-column
                                prop="consignee"
                                show-overflow-tooltip
                                label="合同下载">
                                <template slot-scope="scope">
                                  <a target="_blank" :href="scope.row.contractPath">查看</a>
                                </template>
                              </el-table-column>
                              <el-table-column
                                prop="createDate"
                                show-overflow-tooltip
                                label="合同时间">
                              </el-table-column>
                            </el-table>
                          </template>
                        </el-tab-pane>
                      </el-tabs>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="orderNo"
                    label="主订单编号"
                    width="210">
                  </el-table-column>
                  <el-table-column
                    prop="createDate"
                    show-overflow-tooltip
                    label="下单时间"
                    width="160">
                  </el-table-column>
                  <el-table-column
                    prop="originalAmount"
                    label="商品原价"
                    width="100">
                  </el-table-column>
                  <el-table-column
                    prop="transportAmount"
                    label="运费金额"
                    width="80">
                  </el-table-column>
                  <el-table-column
                    prop="attachAmount"
                    label="附加费">
                  </el-table-column>
                  <el-table-column
                    prop="rebateAmount"
                    label="退还金额">
                  </el-table-column>
                  <el-table-column
                    prop="couponAmount"
                    label="优惠劵">
                  </el-table-column>
                  <el-table-column
                    prop="preferentialMargins"
                    label="总优惠">
                  </el-table-column>
                  <el-table-column
                    prop="totalAmount"
                    label="总金额">
                  </el-table-column>
                  <el-table-column
                    prop="payAmount"
                    label="实收款">
                  </el-table-column>
                </el-table>
              </el-tab-pane>
            </el-tabs>
          </template>
        </el-table-column>
        <el-table-column
          fixed
          prop="invoiceNo"
          label="发票编号"
          width="220"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          prop="mainOrderNo"
          width="220"
           fixed
          show-overflow-tooltip
          label="主订单编号">
        </el-table-column>
        <el-table-column
          prop="consignee"
           fixed
          label="联系人"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
         fixed
          prop="mobile"
          label="用户名"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
         fixed
          prop="amount"
          label="发票金额"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          prop="status"
           fixed
          :formatter="formatStatus"
          label="开票状态"
          show-overflow-tooltip
          width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 1" style="color:#F56C6C">开票申请中</span>
            <span v-if="scope.row.status == 2" style="color:#67C23A">已开票</span>
          </template>
        </el-table-column>
        <el-table-column
         fixed
          prop="openInvoiceFile"
          label="发票下载">
        </el-table-column>
        <el-table-column
          prop="trackNo"
           fixed
          label="快递编号"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
        fixed
          prop="createDate"
          label="创建时间">
        </el-table-column>
        <el-table-column
        fixed
        width="100"
          label="操作">
          <template slot-scope="scope">
            <el-button
              size="mini"
              v-if="(scope.row.status == 1 || scope.row.status == 2)  && (user.isAdmin || user.isFP)"
              @click="trackInvoice(scope.row)">上传发票</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination :pagination="pagination" v-on:paginationClick="queryPagination"></pagination>
    </el-tab-pane>
    <!-- <el-dialog title="发票物流信息" :visible.sync="dialogFormVisible" width="600px">
      <el-form :model="sendForm">
        <el-form-item label="发票编号" :label-width="formLabelWidth">
          <el-input v-model="sendForm.invoiceNo" disabled ></el-input>
        </el-form-item>
        <el-form-item label="物流公司" :label-width="formLabelWidth">
          <el-select v-model="sendForm.companyId" placeholder="物流公司">
            <el-option
              v-for="item in companyAll.data"
              :key="item.value"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="物流单号" :label-width="formLabelWidth">
          <el-input v-model="sendForm.trackNo"  placeholder="请填写物流单号" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelShow">取 消</el-button>
        <el-button type="primary" @click="submitInvoiceTrack">确 定</el-button>
      </div>
    </el-dialog> -->
    <el-dialog title="线下发票信息" :visible.sync="dialogFormVisible" width="800px">
      <el-form :model="sendForm">
        <el-form-item label="发票编号" :label-width="formLabelWidth">
          <el-input v-model="sendForm.invoiceNo" disabled ></el-input>
        </el-form-item>
        <el-form-item label="开票金额" :label-width="formLabelWidth">
          <el-input v-model="sendForm.invcAmount"  placeholder="开票金额" autocomplete="off" disabled></el-input>
        </el-form-item>
        <el-form-item label="上传发票" :label-width="formLabelWidth">
          <el-upload
            class="upload-demo"
            :action="serverUrl"
            :on-success="uploadSuccMethod"
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            :file-list="fileList">
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
          </el-upload>
        </el-form-item>
        <!-- <el-form-item label="物流公司" :label-width="formLabelWidth">
          <el-select v-model="sendForm.companyId" placeholder="物流公司">
            <el-option
              v-for="item in companyAll.data"
              :key="item.value"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="物流单号" :label-width="formLabelWidth">
          <el-input v-model="sendForm.trackNo"  placeholder="请填写物流单号" autocomplete="off"></el-input>
        </el-form-item> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="cancelShow">取 消</el-button>
        <el-button size="mini" type="primary" @click="submitInvoiceTrack">确 定</el-button>
      </div>
    </el-dialog>
   </el-tabs>
</template>
<script>
import pagination from "../../../common/util/pagination";

export default {
  data() {
    return {
      data: [],
      optionItem: {},
      formLabelWidth: '140px',
      dialogFormVisible:false,
      dialogOrderFormVisible: false,
      activeMainName: 'firstMain',
      activeName: 'first',
      addressList: [],
      payList:[],
      fileList: [],
      serverUrl: "https://admin.ruidan.com/api/upload/load/invcs", // 这里写你要上传的图片服务器地址
      // serverUrl: "http://127.0.0.1:7006/upload/load/invcs",
      sendForm: {
        trackNo: '',
        companyId: 3,
        fileList: [],
        invoiceNo: '',
        invcAmount: 0,
        token: this.user.getToken()
      },
      companyForm: {
        token: this.user.getToken()
      },
      orderInvoiceForm: {
        orderNo: '',
        userName: '',
        status: 1,
        token: this.user.getToken()
      },
      pagination: {
        pageSize: 10,
        pageNum: 1,
        pageTotal: 0
      },
      companyAll: {
        data: []
      },
      orderNos: '',
      options: [{
          value: 1,
          label: '普通发票'
        }, {
          value: 2,
          label: '专用发票'
        }, {
          value: 3,
          label: '个人'
        }]
    };
  },
  components: {
    pagination
  },
  methods: {
    handleSelectionChange: function(rows) {
      this.orderNos = ''
      rows.forEach((item) => {
        this.orderNos += item.orderNo + ','
      })
    },
    getOrderData: function() {
      this.optionItem = this.common.extend(this.orderInvoiceForm, this.pagination);
      // 初始化默认加载菜单
      this.http.post(
        '/offline/user/invoice/record/list',
        this.optionItem,
        res => {
          if (res.success) {
            // 返回正确的处理
            this.data = res.datas.data;
            this.pagination.pageSize = res.datas.page.pageSize
            this.pagination.pageNum = res.datas.page.pageNum
            this.pagination.pageTotal = res.datas.page.pageCount
          } else {
            // 返回错误的处理
            this.$message.error(res.message)
          }
        }
      );
    },
    formatPay: function(row, column, cellValue) {
      if (cellValue === 1) {
        return "微信";
      } else if (cellValue === 2) {
        return "支付宝";
      } else if (cellValue === 3) {
        return "对公付款";
      }
    },
    formatPayType: function(row, column, cellValue) {
      if (cellValue === 1) {
        return "付款";
      } else if (cellValue === 2) {
        return "附加费";
      } else if (cellValue === 3) {
        return "退款";
      } else if (cellValue === 4) {
        return "部分退还";
      } else if (cellValue === 5) {
        return "优惠退还";
      }
    },
    formatPayStatus: function(row, column, cellValue) {
      if (cellValue === 1) {
        return "未付款";
      } else if (cellValue === 2) {
        return "已付款";
      } else if (cellValue === 3) {
        return "失败";
      } else if (cellValue === 4) {
        return "部分付款";
      }
    }, 
    formatStatus: function(row, column, cellValue) {
      if (cellValue === 1) {
        return "开票申请中";
      } else if (cellValue === 2) {
        return "已开票";
      }
    },
    formatAddress: function(row, column, cellValue) {
      if(cellValue) {
        return cellValue.province + ' ' + cellValue.city + ' ' + cellValue.area + ' ' + cellValue.addressDetail;
      }
    },
    onSubmit: function() {
      this.pagination.pageNum = 1
      this.getOrderData()
    },
    queryPagination: function(currPage) {
      this.pagination.pageNum = currPage
      this.getOrderData()
    },
    uploadSuccMethod(res) {
      this.fileList.push(res.data)
      this.sendForm.fileList = this.fileList
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    uploadInvoice: function(row) {
      
    },
    handleClick(sval) {
      if (this.activeName =='six') {
      }
    },
    getExpressCompanyList: function() {
      this.optionItem = this.common.extend(this.companyForm, this.pagination)
      // 初始化默认加载菜单
      this.http.post(
       '/expressCompany/list', 
        this.optionItem, res => {
          if (res.success) {
            // 返回正确的处理
            this.companyAll.data = res.datas.data
          } else {
            // 返回错误的处理
            this.$message.error(res.message)
          }
      });
    },
    trackInvoice: function(row) {
      this.dialogFormVisible = true
      this.sendForm.invoiceNo = row.invoiceNo 
      this.sendForm.trackNo = row.trackNo
      this.sendForm.invcAmount = row.amount
      // this.getExpressCompanyList()
    },
    submitInvoiceTrack: function() {
      this.http.post(
        '/offline/user/invoice/track', 
        this.sendForm, res => {
          if (res.success) {
            // 返回正确的处理
            this.getOrderData()
            this.dialogFormVisible = false
          } else {
            // 返回错误的处理
            this.$message.error(res.message)
          }
      });
    },
    cancelShow: function() {
      this.dialogFormVisible = false
      this.sendForm.invoiceNo = ''
    },
    
  },
  mounted: function() {
    this.getOrderData()
  },
};
</script>


<style>
.invoice-css {
  padding: 10px 0 20px 0; width: 60%; text-align:center;
}
.el-table th {
  background: #F5F7FA;
}
.el-table__expanded-cell {  
  padding: 0px 0px 15px 47px !important;
}
.el-tabs {
  border:1px solid #eee;
}
.el-tabs__nav {
  padding: 0 20px;
}
.el-tabs__active-bar {
  margin-left: 20px;
}
.el-input--suffix .el-input__inner {
  padding-right: 16px;
}

.demo-table-expand {
  font-size: 0;
}
.el-form-item__content {
  line-height: none;
}
.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}
.el-table .success-refund{
  background: #FFF;
}
.el-table .success-paid{
  background:#FFF;
}

.el-table .success-over {
  background: #f5f7fa;
}
</style>


// WEBPACK FOOTER //
// src/components/views/invoice/offline/invoiceApplyRecrodList.vue